import { FunctionComponent } from "react";
import { Switch, FormControl, FormLabel } from "@chakra-ui/react";
import { size } from "src/types/size";

type Props = {
  label?: string;
  size?: size;
  value?: string;
  isChecked?: boolean;
  isDisabled?: boolean;
  defaultChecked?: boolean;
  handleChange?: (e?: any) => void;
  alignItems?: "left" | "right" | "center";
  labelDirection?: "row" | "row-reverse" | "column-reverse" | "column";
  justifyContent?: "flex-start" | "flex-end" | "center";
  color?: string;
  fontWeight?: string | number;
  fontSize?: number | string;
};

export const CustomSwitch: FunctionComponent<Props> = ({
  label,
  size,
  isChecked,
  isDisabled,
  value,
  alignItems,
  handleChange,
  labelDirection,
  justifyContent,
  color,
  fontWeight,
  fontSize,
  defaultChecked,
}) => {
  return (
    <FormControl
      display="flex"
      alignItems={alignItems || "center"}
      flexDirection={labelDirection}
      justifyContent={justifyContent}
      gap={2}
    >
      {label && (
        <FormLabel
          htmlFor={label}
          color="primary"
          fontSize={fontSize || "14px"}
          fontWeight={fontWeight}
          mb={0}
        >
          {label}
        </FormLabel>
      )}
      <Switch
        size={size || "md"}
        value={value}
        onChange={handleChange}
        isChecked={isChecked}
        defaultChecked={defaultChecked}
        isDisabled={isDisabled}
        id={label}
        css={{
          "& input:checked + span": {
            backgroundColor: color || "#CF2CA0",
          },
        }}
      />
    </FormControl>
  );
};
